export function getReadablePrice(price: number) {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}
export function randomBetween(max: number, min: number) {
    return Math.floor(Math.random() * (max - min) ) + min;
}